import ApplicationAdapter from 'eflex/adapters/application';

export default class KineticPartAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
